"use client";

import React, { useEffect } from "react";

import useNavigation from "../../hooks/useNavigation";

type Props = {
  to: string;
  replace?: boolean;
};

const Redirect: React.FC<Props> = ({ to, replace }) => {
  const navigation = useNavigation();
  useEffect(() => {
    if (replace) {
      navigation.replace(to);
    } else {
      navigation.push(to);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [to, replace]);
  return null;
};

export default Redirect;
